import React from 'react'
import ICSErrorCard from '../../../../components/ICSErrorCard/ICSErrorCard'
import { updateUserPreference, UserPreferenceStateItem } from '../../../../redux/slices'
import { Col, Container, Row, Button } from 'reactstrap'
import { useDispatch } from 'react-redux'
import { useAppSelector } from '../../../../hooks/useAppSelector'
import RenderDataModal from '../RenderViewModal/RenderViewModal'
import { LoadIndicator } from 'devextreme-react'

//import './SettingsModal.css'

export interface SearchSettingsDialogProps {
  onClose: () => void
}
const SearchSettingsDialog: React.FC<SearchSettingsDialogProps> = ({ onClose }) => {
  return (
      <RenderDataModal onClose={onClose} title='Settings' className='settings-modal'>
        <_SettingButton name="flatten">
          Normally the zip files are structured by vehicle name and upload. Enabling this setting will
          put all files in the root of the generated zip file.
        </_SettingButton>
        <_SettingButton name="filenameTimezoneConvert">
          When downloading, convert the date and time of the data file names to my selected timezone.
        </_SettingButton>
        <_SettingButton name="filenameTimezoneIso">
          When downloading, format the date and time in file names as ISO 8601 with timezone.
          Uses a Windows-safe form without colons. If convert to my timezone is off, filenames use Z (UTC).
          If convert is on, filenames use the selected timezone offset. This does not alter the date and
          time of the data itself, just the filename.
        </_SettingButton>
        <_SettingButton name="hidePersistentFiles">
          Hide auto-generated persistent data and signal files.
        </_SettingButton>
      </RenderDataModal>
  )
}

interface _SettingButtonProps {
    name: string
}
export const _SettingButton: React.FC<_SettingButtonProps> = ({
    name,
    children
}) => {
    const pref = useAppSelector(state => state.userPreference.data[name])
    const dispatch = useDispatch()

    const prefVal = (pref?.val || 'false') === 'true' ? true : false

    const toggleValue = () => {
      dispatch(updateUserPreference({
        id: pref?.id || undefined,
        name,
        val: (!prefVal).toString()
      }))
    }

  const getBody = () => {    
    const error = pref?.error || null

    if(pref?.loading || false) {
      return <LoadIndicator />
    } else if(error !== null) {
      return(
            <ICSErrorCard
              code={'error'}
              message={error}
              fields={[]}
            />
      )
    } else {
      return (
        <Row className="align-items-center">
            <Col xs="auto">
                <Button onClick={toggleValue} color={prefVal ? 'success' : 'secondary'}>
                  {prefVal ? 'On' : 'Off'}
                </Button>
            </Col>
            <Col>
                {children}
            </Col>
        </Row>
      )
    }
  }

  return (
      <div className='m-2'>
        {getBody()}
      </div>
  )
}

export default SearchSettingsDialog